import {
  Box,
  Button,
  FormControl,
  Heading,
  HStack,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaGoogle } from "react-icons/fa";
import { useGoogleSignIn } from "../../../hooks/useGoogleSignIn.ts";
import { useSignIn } from "../../../hooks/useSignIn.ts";
import Email from "./email.tsx";
import Password from "./password.tsx";

export const SignIn = ({ setForgot }: { setForgot: (x: boolean) => void }) => {
  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: {
      login: "",
      password: "",
    },
  });
  const { submit, loading } = useSignIn();
  const { handleGoogleSignIn } = useGoogleSignIn();

  const onSubmit = (data) => {
    submit(data);
  };

  return (
      <FormProvider {...methods}>
        <VStack
            justifyContent="center"
            p="40px"
            spacing="20px"
            bg="#f7f8fc"
            borderRadius="10px"
            boxShadow="lg"
            maxW="500px"
            mx="auto"
        >
          <HStack justifyContent="space-between" w="100%">
            <Heading color="#111833" size="lg">
              {t("Sign In")}
            </Heading>
          </HStack>

          <Box
              w="100%"
              display="flex"
              flexDirection="column"
              gap="15px"
              alignItems="center"
          >
            <Button
                leftIcon={<FaGoogle />}
                variant="outline"
                width="100%"
                onClick={handleGoogleSignIn}
                colorScheme="red"
                fontSize="14px"
            >
              {t("Sign in with Google")}
            </Button>
          </Box>

          <Text color="#707070" fontSize="14px">
            {t("Or sign in with your email")}
          </Text>

          <Box
              w="100%"
              bg="white"
              p={{ base: "20px", md: "30px" }}
              borderRadius="10px"
              boxShadow="md"
          >
            <FormControl
                as="form"
                onSubmit={methods.handleSubmit(onSubmit)}
                display="flex"
                flexDirection="column"
                gap="20px"
            >
              <Email />
              <Password />
              <Box display="flex" justifyContent="flex-end">
                <Link
                    onClick={() => setForgot(true)}
                    color="#7848f4"
                    fontWeight="600"
                    fontSize="sm"
                    _hover={{ textDecoration: "underline" }}
                >
                  {t("Forgot password?")}
                </Link>
              </Box>
              <Button
                  mt="20px"
                  w="100%"
                  cursor="pointer"
                  _hover={{ bg: "#090632" }}
                  p="20px 0"
                  type="submit"
                  borderRadius="8px"
                  bg="#111833"
                  color="white"
                  fontSize="18px"
                  fontWeight="600"
                  isLoading={loading}
                  loadingText={t("Signing in...")}
              >
                {t("Sign in")}
              </Button>
            </FormControl>
          </Box>
        </VStack>
      </FormProvider>
  );
};
